function handleLanguageChange() {
  var languageElement = document.querySelector('aside[data-wg-notranslate="true"]');
  if (languageElement) {
    var languageText = languageElement.getAttribute('aria-label');
    var selectedLanguage = languageText.match(/Language selected: ([^\"]+)/)?.[1]?.trim();

    console.log("Selected Language:", selectedLanguage);

    var codeElement = document.getElementById("shopify-block-90a2486d-7623-46bd-acc0-4c56870215e6");
    if (codeElement) {
      codeElement.style.display = (selectedLanguage !== "English") ? "none" : "";
    }
  }
}

function observerCallback(mutationsList) {
  handleLanguageChange();
}

var observerConfig = {
  attributes: true,
  attributeFilter: ['aria-label']
};

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var languageElement = document.querySelector('aside[data-wg-notranslate="true"]');
    if (languageElement) {
      handleLanguageChange(); 
      var observer = new MutationObserver(observerCallback); 
      observer.observe(languageElement, observerConfig); 
    }
  }, 200); 
});

